import { FlexBox, Text } from '@fable/components'
import { Club } from '@fable/types'
import { css } from '@fable/theme'
import { ClubImage } from 'components'
import { formatDate } from 'utils'

const SearchbarResultClub = ({ club }: { club: Club }) => (
  <FlexBox data-testid="resultClub" alignItems="center">
    <ClubImage
      className={css`
        width: 100px;
        height: 100px;
        border-radius: 12px;
        flex-shrink: 0;
      `}
      /**
       * @note
       * `ClubType` is a temp TS fix
       * as we have a conflict of types
       * between 2 sources.
       */
      club={club as Club}
    />
    <div
      className={css`
        margin-left: 16px;
      `}
    >
      <Text
        className={css`
          font-weight: 600;
        `}
        sizing="XS"
        type="subhead"
        text={club.title}
      />
      <Text
        type="label"
        sizing="L"
        text={`with ${club.creator?.display_name}`}
      />
      {club.date_created && (
        <Text type="label" sizing="L" text={formatDate(club.date_created)} />
      )}
    </div>
  </FlexBox>
)

export default SearchbarResultClub
